import http from './http';
import notifier from '../_utils/notifier';
import SubmissionError from 'redux-form/lib/SubmissionError';

const aphorismAPI = {
  getList(page) {
    return http.get('aphorism/', { params: { page } })
    .then(
      function(success) { return success },
      function(error) {
        notifier.alert(gettext('При загрузке страницы произошла ошибка. ') + '<br>' + error.messages);
      }
    )
  },

  create(payload) {
    return http.post('aphorism/', payload)
    .then(
      function(success) { return success },
      function(error) {
        notifier.alert(gettext('При создании цитаты произошла ошибка. ') + '<br>' + error.messages);
        throw new SubmissionError(error.messages);
      }
    )
  },

  delete(id){
    return http.delete(`aphorism/${id}/`)
    .then(
      function(success) { return 'ok' },
      function(error) {
        notifier.alert(gettext('При удалении цитаты произошла ошибка. ') + '<br>' + error.messages);
      }
    )
  },
};


export default aphorismAPI;

